module.exports = __webpack_public_path__ + "static/media/error.b2098339.svg";